import { UPDATE_DMX_CONTROLLER, UPDATE_DMX_CONTROLLER_SUCCESSFUL, UPDATE_DMX_CONTROLLER_FAILED } from './actionTypes';

export const updateDmxController = (controller) => {
  return {
    type: UPDATE_DMX_CONTROLLER,
    payload: { controller },
  };
};

export const updateDmxControllerSuccessful = (message) => {
  return {
    type: UPDATE_DMX_CONTROLLER_SUCCESSFUL,
    payload: message,
  };
};

export const updateDmxControllerFailed = (message) => {
  return {
    type: UPDATE_DMX_CONTROLLER_FAILED,
    payload: message,
  };
};
